export default __webpack_public_path__ + "img/wavedata-missed-alarms-fleet.69e58e8f.jpg";